module.exports = __webpack_public_path__ + "img/confetti.5fbe98ef.png";